import authRules from '../authRules.js';

const viewStatus = (user) => {
  const { status } = user.securityLevels;
  if (status >= authRules.viewStatus.status) {
      return true;
  } else {
      return false;
    }
  }


export default viewStatus;
